var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Linear/addsquare",
    clipPath: "url(#clip0_280_6137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.33325 8H10.6666M7.99992 10.6667V5.33333M5.99992 14.6667H9.99992C13.3333 14.6667 14.6666 13.3333 14.6666 10V6C14.6666 2.66667 13.3333 1.33333 9.99992 1.33333H5.99992C2.66659 1.33333 1.33325 2.66667 1.33325 6V10C1.33325 13.3333 2.66659 14.6667 5.99992 14.6667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_280_6137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSquare);
export default __webpack_public_path__ + "static/media/add-square.3e90941c71c3e75f9422386938f26660.svg";
export { ForwardRef as ReactComponent };